<h1 class="tac permission col-lg-offset-3 col-md-offset-3 col-sm-offset-3">
  It appears you don't have permission to view this page
</h1>

<div class="permission left45 top60" style="padding: 10px 0px 10px 10px;">
  <button class="btn btn-large btn-primary pull-right" type="button" (click)="homePage()">Home Page</button>
</div>
